// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionOverview_container__vOpUg"};